var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wc-layout wc-layout--mobile-default"},[_c('WCMobileHeader'),_c('div',{staticClass:"container-fluid",class:_vm.bodyClass},[_c('WCAlertRoot'),_c('router-view')],1),(_vm.isEmployee && _vm.isCustomer)?_c('WCEmployeeAssociationBanner'):(!_vm.isEmployee)?_c('WCMobileNavigation'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }